module.exports = __webpack_public_path__ + "img/5.6842d03c.png";